import { render, staticRenderFns } from "./DateRangeLegend.vue?vue&type=template&id=5465c51b&scoped=true&"
import script from "./DateRangeLegend.vue?vue&type=script&lang=js&"
export * from "./DateRangeLegend.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeLegend.vue?vue&type=style&index=0&id=5465c51b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5465c51b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5465c51b')) {
      api.createRecord('5465c51b', component.options)
    } else {
      api.reload('5465c51b', component.options)
    }
    module.hot.accept("./DateRangeLegend.vue?vue&type=template&id=5465c51b&scoped=true&", function () {
      api.rerender('5465c51b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JQ25hwKUE9fQ/JS/comp/DateRangeLegend.vue"
export default component.exports